import { preventAndThrottle } from '@/utils';
import React from 'react';
import styles from './PageTitleImageButton.module.scss';
import IconCommon, { DesignSystemIconType } from '@/components/Common/DesignSystem/Icon/IconCommon';

interface IPageTitleImageButtonProps {
  onClick?: (event: React.MouseEvent<Element, MouseEvent>) => void;
  onBeforeClick?: () => void;
  type: DesignSystemIconType;
  altText?: string;
}

const PageTitleImageButton: React.FC<IPageTitleImageButtonProps> = ({ onClick, onBeforeClick, type, children, altText }) => (
  <button className={styles.button} onClick={onClick && preventAndThrottle(onClick, onBeforeClick)} aria-label={altText}>
    <IconCommon type={type} />
    {children}
  </button>
);

export default PageTitleImageButton;
